import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../images/roeicarE.png"
import Context from "../../storage/context";

const Footer = () => {

    const ctx = useContext(Context)
    let navigate = useNavigate();




    const onClick = (e) => {
        ctx.setTabSelectedUser(e.target.innerText)
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        switch (e.target.innerText) {
            case "חיפוש רכבים":
                navigate("/searchCar", { replace: true });
                break;
            case "אודות":
                navigate("/about", { replace: true });
                break;
            case "לקוחות ממליצים":
                navigate("/reviews", { replace: true });
                break;
            case "יצירת קשר":
                navigate("/contact", { replace: true });
                break;

        }
    }

    const IgIcon = () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="url(#ig-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <defs>
                <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#f09433" />
                    <stop offset="25%" stopColor="#e6683c" />
                    <stop offset="50%" stopColor="#dc2743" />
                    <stop offset="75%" stopColor="#cc2366" />
                    <stop offset="100%" stopColor="#bc1888" />
                </linearGradient>
            </defs>
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="1" fill="#e6683c" stroke="none" />
        </svg>
    );

    const FbIcon = () => (
        <svg viewBox="0 0 24 24" fill="#1877f2" stroke="none">
            <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.932-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
        </svg>
    );


    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-grid">
                    <div>
                        <div className="footer-brand">
                            <img src={logo} alt="Roei Car" style={{ width: 190, height: 70 }} loading="lazy" />
                        </div>
                        <p className="footer-desc">המקום הכי חכם לקנות בו רכב יד 2</p>
                    </div>
                    <div>
                        <div className="footer-col-title">ניווט</div>
                        {["חיפוש רכבים", "לקוחות ממליצים", "יצירת קשר", "אודות"].map(l => <a key={l} onClick={onClick} className="footer-link">{l}</a>)}
                    </div>

                    <div className="footer-col-title">
                        <div className="footer-col-title">צרו קשר</div>
                        <div className="footer-contact-item">📞 050-7667702</div>
                        <div className="footer-contact-item">✉️ hilaben3112@gmail.com</div>
                        <div className="footer-contact-item">📍 חיפה,גאולה 19, ישראל</div>
                    </div>
                </div>
                <div className="footer-divider" />
                <div className="footer-bottom">
                    <span className="footer-copy">© 2025 RoeiCar. כל הזכויות שמורות.</span>
                    <div className="footer-socials">
                        <a href="https://www.instagram.com/roei_car/" target="_blank" rel="noreferrer">
                            <div className="ct-card__ico"><IgIcon /></div>
                        </a>
                        <a href="https://www.facebook.com/Roeihila/?locale=he_IL" target="_blank" rel="noreferrer">
                            <div className="ct-card__ico"><FbIcon /></div>

                            <div className="ct-card__arrow">←</div>
                        </a>
                    </div>
                </div>
            </div>
        </footer >
    );
};

export default Footer;